module.exports = __webpack_public_path__ + "static/media/ic_q.59dbd95e.svg";